import { submitTINRequest } from './requests';

export const submitTINRequestSaga = async ({ action }) => {
  return submitTINRequest(action.payload);
};
